"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _swiper = _interopRequireWildcard(require("swiper"));
var _react2 = require("swiper/react");
require("swiper/swiper-bundle.css");
var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _ImageGallery = _interopRequireDefault(require("../ImageGallery.proptypes"));
var _constant = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
_swiper.default.use([_swiper.Virtual]);
var Img = _styledComponents.default.img.withConfig({
  displayName: "ImageGalleryMobile__Img",
  componentId: "sc-16pk08-0"
})(["width:100%;height:auto;object-fit:cover;border-radius:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.micro;
});
Img.displayName = 'Img';
var LargeImg = _styledComponents.default.img.withConfig({
  displayName: "ImageGalleryMobile__LargeImg",
  componentId: "sc-16pk08-1"
})(["width:100%;height:auto;"]);
LargeImg.displayName = 'LargeImg';
var SlideContainer = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryMobile__SlideContainer",
  componentId: "sc-16pk08-2"
})(["height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;"]);
var GalleryContainer = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryMobile__GalleryContainer",
  componentId: "sc-16pk08-3"
})(["display:grid;grid-template-rows:56px ", " auto;height:100%;width:100%;position:relative;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.large;
});
var GalleryHeader = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryMobile__GalleryHeader",
  componentId: "sc-16pk08-4"
})(["display:flex;align-items:center;height:56px;padding:0 ", ";box-shadow:0px 2px 6px rgba(0,0,0,0.2);z-index:1;min-width:0;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.small;
});
var BackButton = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryMobile__BackButton",
  componentId: "sc-16pk08-5"
})(["margin-right:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.small;
});
var Category = _styledComponents.default.span.withConfig({
  displayName: "ImageGalleryMobile__Category",
  componentId: "sc-16pk08-6"
})(["margin-right:", ";font-size:", ";line-height:", ";color:", ";font-family:", ";display:flex;align-items:center;font-weight:", ";border-bottom:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.XSmall;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSize.small;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.lineHeight.large;
}, function (_ref8) {
  var theme = _ref8.theme,
    bold = _ref8.bold,
    move = _ref8.move;
  return bold ? move && theme.colors.secondary || theme.colors.neutral : theme.colors.greyDarker;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontFamily.default;
}, function (_ref10) {
  var bold = _ref10.bold;
  return bold ? 500 : 'normal';
}, function (_ref11) {
  var theme = _ref11.theme,
    bold = _ref11.bold,
    move = _ref11.move;
  return bold ? "2px solid ".concat(move && theme.colors.secondary || theme.colors.primary) : "2px solid ".concat(theme.colors.greyLighter);
});
Category.displayName = 'Category';
var EmptyCategory = _styledComponents.default.span.withConfig({
  displayName: "ImageGalleryMobile__EmptyCategory",
  componentId: "sc-16pk08-7"
})(["margin-right:", ";width:", ";opacity:0;"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.small;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.space.small;
});
var CategoriesContainer = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryMobile__CategoriesContainer",
  componentId: "sc-16pk08-8"
})(["display:flex;height:", ";flex-direction:row;overflow-x:auto;padding:0 ", ";white-space:nowrap;background-color:", ";border-bottom:1px solid ", ";", ":last-child{margin-right:", ";}&::-webkit-scrollbar{display:none;}"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.large;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.small;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.greyLighter;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.greyLight;
}, Category, function (_ref18) {
  var theme = _ref18.theme;
  return theme.space.small;
});
var HotelInfo = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryMobile__HotelInfo",
  componentId: "sc-16pk08-9"
})(["display:inline-grid;"]);
var EllipsisText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "ImageGalleryMobile__EllipsisText",
  componentId: "sc-16pk08-10"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;"]);
var ImageListContainer = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryMobile__ImageListContainer",
  componentId: "sc-16pk08-11"
})(["overflow-y:auto;overflow-x:hidden;position:relative;padding:", ";"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.space.small;
});
ImageListContainer.displayName = 'ImageListContainer';
var MansoryContainer = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryMobile__MansoryContainer",
  componentId: "sc-16pk08-12"
})(["display:grid;grid-gap:", "px;grid-template-columns:repeat(auto-fill,minmax(", "px,1fr));grid-auto-rows:", "px;"], _constant.GRID_ROW_GAP, _constant.GRID_ITEM_MIN_WIDTH, _constant.GRID_ROW_HEIGHT);
var BackToTop = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryMobile__BackToTop",
  componentId: "sc-16pk08-13"
})(["display:flex;cursor:pointer;position:fixed;background-color:", ";padding-right:", ";align-items:center;width:50px;height:32px;justify-content:center;z-index:1000;border-radius:4px 0px 0px 4px;right:0;bottom:", ";"], function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.neutral;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.space.small;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.space.small;
});
BackToTop.displayName = 'BackToTop';
var ImageModal = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryMobile__ImageModal",
  componentId: "sc-16pk08-14"
})(["position:absolute;width:100%;height:100%;background-color:", ";display:flex;flex-direction:column;justify-content:space-between;z-index:9999;.swiper-container{width:100%;flex:1;}.swiper-slide{display:flex;align-items:center;flex-direction:row;}"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.neutral;
});
ImageModal.displayName = 'ImageModal';
var CloseIcon = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryMobile__CloseIcon",
  componentId: "sc-16pk08-15"
})(["padding:", ";display:flex;flex-direction:row-reverse;"], function (_ref24) {
  var theme = _ref24.theme;
  return theme.space.normal;
});
CloseIcon.displayName = 'CloseIcon';
var ModalFooter = _styledComponents.default.div.withConfig({
  displayName: "ImageGalleryMobile__ModalFooter",
  componentId: "sc-16pk08-16"
})(["display:flex;justify-content:space-between;align-items:flex-end;padding:", ";"], function (_ref25) {
  var theme = _ref25.theme;
  return "".concat(theme.space.small, " ").concat(theme.space.small, " ").concat(theme.space.semiLarge, " ").concat(theme.space.small);
});
var ImageGalleryMobile = function ImageGalleryMobile(_ref26) {
  var accessible = _ref26.accessible,
    theme = _ref26.theme,
    className = _ref26.className,
    images = _ref26.images,
    customProperties = _ref26.customProperties,
    hotelDetail = _ref26.hotelDetail,
    onClose = _ref26.onClose,
    allLabel = _ref26.allLabel,
    onImageEnlarge = _ref26.onImageEnlarge,
    isRoomDetail = _ref26.isRoomDetail,
    move = _ref26.move;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var galleryContainerRef = (0, _react.useRef)();
  var firstImg = (0, _react.useRef)();
  var categoryListRef = (0, _react.useRef)();
  var selectedCategoryRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showScroll = _useState2[0],
    setShowScroll = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    imageModalVisible = _useState4[0],
    showImageModal = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    selectedCategory = _useState6[0],
    selectCategory = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    categories = _useState8[0],
    setCategories = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    filteredImages = _useState10[0],
    setFilteredImages = _useState10[1];
  var _useState11 = (0, _react.useState)(),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    selectedImage = _useState12[0],
    selectImage = _useState12[1];

  // Array of all images from every category so that user can swipe through categories
  var _useState13 = (0, _react.useState)([]),
    _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
    swipeImages = _useState14[0],
    setSwipeImages = _useState14[1];
  // To make sure we can update the right category when user swipe
  var _useState15 = (0, _react.useState)({}),
    _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
    categoryIndexOffset = _useState16[0],
    setIndexOffset = _useState16[1];
  var scrollTop = function scrollTop() {
    galleryContainerRef.current.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  var checkScrollTop = function checkScrollTop() {
    var firstImgRect = firstImg.current.getBoundingClientRect();
    if (!showScroll && firstImgRect.y < _constant.SHOW_SCROLL_TOP_DISTANCE) {
      setShowScroll(true);
    } else if (showScroll && firstImgRect.y >= _constant.SHOW_SCROLL_TOP_DISTANCE) {
      setShowScroll(false);
    }
  };
  var tabIndex = !accessible ? '-1' : '0';
  (0, _react.useEffect)(function () {
    if (images.length === 0) {
      setCategories([]);
    } else {
      var categoryMap = {};
      if (!isRoomDetail) {
        images.forEach(function (image) {
          if (image.category && image.category.id) {
            if (!categoryMap[image.category.id]) {
              categoryMap[image.category.id] = _objectSpread(_objectSpread({}, image.category), {}, {
                count: 1
              });
            } else {
              categoryMap[image.category.id] = _objectSpread(_objectSpread({}, categoryMap[image.category.id]), {}, {
                count: categoryMap[image.category.id].count + 1
              });
            }
          }
        });
      }
      var categoriesArray = Object.values(categoryMap).sort(function (a, b) {
        return a.name > b.name ? 1 : -1;
      });
      categoriesArray.unshift({
        name: allLabel,
        count: images.length,
        id: 0
      });
      var imagesByCategory = images; // All images
      var offsetMap = {
        0: 0
      };
      var lastIndex = images.length;
      categoriesArray.forEach(function (category, index) {
        if (index > 0) {
          // skip 'All' category
          offsetMap[category.id] = lastIndex;
          lastIndex += category.count;
          imagesByCategory = imagesByCategory.concat(images.filter(function (image) {
            var _image$category;
            return ((_image$category = image.category) === null || _image$category === void 0 ? void 0 : _image$category.id) === category.id;
          }));
        }
      });
      setIndexOffset(offsetMap);
      setSwipeImages(imagesByCategory);
      setCategories(categoriesArray);
      selectCategory(0);
    }
  }, [images, allLabel, isRoomDetail]);
  (0, _react.useEffect)(function () {
    if (selectedCategory === 0) {
      setFilteredImages(images);
    } else {
      setFilteredImages(images.filter(function (image) {
        var _image$category2;
        return ((_image$category2 = image.category) === null || _image$category2 === void 0 ? void 0 : _image$category2.id) === selectedCategory;
      }));
    }
  }, [selectedCategory, images]);
  (0, _react.useEffect)(function () {
    var categoryList = categoryListRef.current;
    if (selectedCategoryRef.current && categoryList.scrollTo) {
      categoryList.scrollTo({
        left: selectedCategoryRef.current.offsetLeft - _constant.CATEGORY_ITEM_GAP,
        behavior: 'smooth'
      });
    }
  }, [selectedCategory]);
  var resizeGridItem = function resizeGridItem(event) {
    var item = event.target;
    var rowSpan = Math.ceil((item.getBoundingClientRect().height + _constant.GRID_ROW_GAP) / (_constant.GRID_ROW_HEIGHT + _constant.GRID_ROW_GAP));
    item.style.gridRowEnd = "span ".concat(rowSpan);
    item.style.height = "100%";
  };
  var galleryComponent = function galleryComponent() {
    var _categories$find;
    return /*#__PURE__*/_react.default.createElement(GalleryContainer, (0, _extends2.default)({
      tabIndex: tabIndex,
      className: className
    }, customProperties), /*#__PURE__*/_react.default.createElement(GalleryHeader, null, /*#__PURE__*/_react.default.createElement(BackButton, {
      role: "button",
      onClick: onClose,
      tabIndex: tabIndex,
      onKeyDown: onClose
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      fontsize: "titleNormal",
      icon: _constant.ARROW_BACK_ICON,
      accessible: accessible,
      color: "greyDark"
    })), /*#__PURE__*/_react.default.createElement(HotelInfo, null, /*#__PURE__*/_react.default.createElement(EllipsisText, {
      color: "neutral",
      bold: true
    }, hotelDetail.name), /*#__PURE__*/_react.default.createElement(EllipsisText, {
      color: "greyDark",
      type: "small"
    }, hotelDetail.address.city, ", ", hotelDetail.address.country))), /*#__PURE__*/_react.default.createElement(CategoriesContainer, {
      ref: categoryListRef
    }, categories.map(function (_ref27) {
      var name = _ref27.name,
        id = _ref27.id,
        count = _ref27.count;
      return /*#__PURE__*/_react.default.createElement(Category, {
        key: id,
        bold: id === selectedCategory,
        ref: id === selectedCategory ? selectedCategoryRef : undefined,
        onClick: function onClick() {
          selectCategory(id);
        },
        move: move
      }, "".concat(name, " (").concat(count, ")"));
    }), /*#__PURE__*/_react.default.createElement(EmptyCategory, null, "."), " "), /*#__PURE__*/_react.default.createElement(ImageListContainer, {
      ref: galleryContainerRef,
      onScroll: checkScrollTop
    }, /*#__PURE__*/_react.default.createElement(MansoryContainer, null, filteredImages.map(function (image, index) {
      return /*#__PURE__*/_react.default.createElement(Img, {
        src: image.links.small || image.links.big,
        alt: image.alt || image.caption || 'TBD',
        key: image.id,
        ref: index === 0 ? firstImg : null,
        onClick: function onClick() {
          selectImage(image);
          showImageModal(true);
          onImageEnlarge();
        },
        onLoad: resizeGridItem
      });
    })), showScroll && /*#__PURE__*/_react.default.createElement(BackToTop, {
      onClick: scrollTop
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      fontsize: "titleNormal",
      icon: _constant.EXPAND_LESS_ICON,
      accessible: accessible,
      color: "default"
    }))), imageModalVisible && /*#__PURE__*/_react.default.createElement(ImageModal, null, /*#__PURE__*/_react.default.createElement(CloseIcon, {
      onClick: function onClick() {
        showImageModal(false);
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      fontsize: "titleNormal",
      icon: _constant.CLOSE_ICON,
      accessible: accessible,
      color: "default"
    })), /*#__PURE__*/_react.default.createElement(_react2.Swiper, {
      virtual: true,
      spaceBetween: 0,
      slidesPerView: 1,
      onTransitionEnd: function onTransitionEnd(_ref28) {
        var activeIndex = _ref28.activeIndex;
        var newSelectedImage = swipeImages[activeIndex];
        selectImage(newSelectedImage);
        // eslint-disable-next-line react/prop-types
        var catId = activeIndex < images.length ? 0 : newSelectedImage.category.id;
        selectCategory(catId);
      },
      onInit: function onInit(swiper) {
        swiper.slideTo(filteredImages.indexOf(selectedImage) + categoryIndexOffset[selectedCategory], 0);
      }
    }, swipeImages.map(function (image, index) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react.default.createElement(_react2.SwiperSlide, {
          key: "".concat(index, "-").concat(image.id)
        }, /*#__PURE__*/_react.default.createElement(SlideContainer, null, /*#__PURE__*/_react.default.createElement(LargeImg, {
          src: image.links.big || image.links.small,
          alt: image.alt || image.caption || 'TBD'
        })))
      );
    })), /*#__PURE__*/_react.default.createElement(ModalFooter, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "default",
      bold: true
    }, !isRoomDetail ? selectedImage === null || selectedImage === void 0 ? void 0 : selectedImage.caption : hotelDetail.name), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "default",
      bold: true
    }, filteredImages.indexOf(selectedImage) + 1, "/", (_categories$find = categories.find(function (cat) {
      return cat.id === selectedCategory;
    })) === null || _categories$find === void 0 ? void 0 : _categories$find.count))));
  };
  return themeContext ? galleryComponent() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, galleryComponent());
};
ImageGalleryMobile.propTypes = _ImageGallery.default.PropTypes;
ImageGalleryMobile.defaultProps = _ImageGallery.default.DefaultProps;
var _default = ImageGalleryMobile;
exports.default = _default;